import React from 'react'
import { createPortal } from 'react-dom'
import EventHypeStrip from '../../../components/EventHypeStrip'
import request from 'graphql-request'

class EventHypeStripWidget extends React.Component {
  constructor(props) {
    super(props)
    this.state = { article: null }

    this.nodeElement =
      typeof window !== 'undefined' && document.getElementById('body-start')
  }

  async UNSAFE_componentWillMount() {
    const query = `
    {
      article(_id: "${this.props.eventId}") {
        _id
        headline
        eventStartDate
        eventEndDate
        hypeStripColour
        images
        locationUrl
      }
    }`
    const { article } = await request(
      `${process.env.GATSBY_API_URL}/graphql`,
      query
    )

    if (article) {
      this.setState({ article: article[0] })
    }
  }

  render() {
    if (!this.nodeElement) return null

    return createPortal(
      <EventHypeStrip {...this.state.article} />,
      this.nodeElement
    )
  }
}

export default EventHypeStripWidget
